<!-- components/shared/info-field/info-field.html -->
<div class="info-field">
  <div class="info-container">
    <div *ngFor="let item of data" class="item"
         [class.image-item]="item.type === 'image'"
         [class.text-item]="item.type === 'text'"
         [class.status-item]="item.type === 'status'"
         [class.button-item]="item.type === 'new-simulation-button'">

      <!-- Imagem -->
      <img
        *ngIf="item.type === 'image'"
        [src]="item.imageUrl"
        [alt]="item.imageAlt || 'Imagem informativa'"
        class="info-image">

      <!-- Texto -->
      <div *ngIf="item.type === 'text'" class="text-content">
        <h3 class="info-title">{{ item.title }}</h3>
        <p class="info-text">{{ item.info }}</p>
      </div>

      <!-- Status -->
      <div *ngIf="item.type === 'status'" class="status-content">
        <h3 class="info-title">{{ item.title }}</h3>

        <!-- Valor com badge ao lado -->
        <div class="status-value-container">
          <div class="status-badge" [class]="getStatusBadgeClass(item.info || '')"></div>
          <p class="info-text">{{ item.info }}</p>
        </div>

        <!-- Botão Alterar Status COM TRACKING -->
        <button
          class="change-status-button"
          (click)="openChangeStatusLeadModal()"
          appTrackClick
          trackEvent="alterarstatus_leads"
          trackCategory="lead_details"
          trackLabel="change_status_button">
          Alterar Status
        </button>
      </div>

      <!-- Botão Gerar Nova Simulação -->
      <div *ngIf="item.type === 'new-simulation-button'" class="new-simulation-button-container">
        <button class="new-simulation-button" (click)="handleButtonClick(item)">
          {{ item.buttonText || 'Gerar nova simulação' }}
        </button>
      </div>
    </div>
  </div>
</div>
